




























import { Component, Vue, Inject, Ref, Watch } from 'vue-property-decorator';

import CampagnaList from './CampagnaList.vue';
import { CrudService } from '@/data/services/crud.service';
import { Campaign, CampaignStatus } from '@/data/models/campaign.model';
import CampagnaFilter from './CampagnaFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';

@Component({
	components: {
		CampagnaList,
		CampagnaFilter,
	},
})
export default class Campagnas extends Vue {
	@Inject('CrudService') crudService!: CrudService<Campaign>;

	@Ref('list') list!: CampagnaList;
	@Ref('filter') filter!: CampagnaFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadCampagne();
	}

	deleteCampagna(item: Campaign) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-campagna-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Campaign, 'campaign', item)
					.then(() => {
						this.list.loadCampagne();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

	lockCampagna(item: Campaign) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-campagna-lock') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				item.status = CampaignStatus.LOCKED;
				this.crudService
					.createEntity(Campaign, 'campaign', item)
					.then(() => {
						this.list.loadCampagne();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

}
